import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import EA from '../helpers/init';

export default EA.Methods.testimonialSliderHandler = ($this) => {
    const slider = $this.querySelector('.testimonial-swiper');
    const amountOfSlides = slider.querySelectorAll('.swiper-slide').length;

    const pagination = $this.querySelector('.swiper-pagination');

    const twoDigits = new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false 
    });

    new Swiper(slider, {
        modules: [Autoplay, Pagination],
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: amountOfSlides >= 5 ? true : false,
        loopAdditionalSlides: 1,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: pagination,
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                return `
                    <span class="current-slide">${twoDigits.format(current)}</span>
                    <span class="separator"></span>
                    <span class="total-slides">${twoDigits.format(total)}</span>
                `;
            }
        },
        breakpoints: {
            601: {
                spaceBetween: 24
            }
        },
        on: {
            afterInit(s) {
                if(amountOfSlides >= 5) {
                    s.slidePrev(0, false);
                    s.slideNext(0, false);
                }
            },
        },
    });
};